import clsx from 'clsx'
import {Button, ButtonProps} from './Button'

export interface BigButtonProps extends Omit<ButtonProps, 'size'> {}

export const BigButton = ({className, ...buttonProps}: BigButtonProps) => {
  return <Button className={clsx('big-button', className)} {...buttonProps}></Button>
}
